"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledDivOverlay = exports.DetailIcon = exports.GalleryCard = exports.GalleryCardTitle = exports.MultipleAssetsIcon = exports.StyledPlayCircleOutlined = exports.StyledPlusOutlined = exports.AddGalleryButton = exports.GalleryCardAssetImageWrapper = exports.GalleryCardsContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const icons_1 = require("@ant-design/icons");
const elements_1 = require("@src/components/elements");
const streamlinehq_picture_stack_svg_1 = __importDefault(require("@public/media/icons/streamlinehq-picture-stack.svg"));
const styled_breakpoints_1 = require("styled-breakpoints");
exports.GalleryCardsContainer = styled_components_1.default.div `
	display: grid;
	grid-template-columns: minmax(100px, 1fr);
	justify-items: center;
	gap: 1rem;

	${(0, styled_breakpoints_1.up)('sm')} {
		grid-template-columns: repeat(2, minmax(100px, 1fr));
	}
`;
exports.GalleryCardAssetImageWrapper = styled_components_1.default.div `
	width: 100%;
	height: 250px;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;

	img {
		height: 100%;
		width: 100%;
		max-width: 100%;
		max-height: 100%;
		object-fit: cover;
	}
`;
exports.AddGalleryButton = (0, styled_components_1.default)(elements_1.Button) `
	width: 100%;
	height: 250px;
	font-size: 1.25rem;
	background: url('/media/images/background-gradient.jpg') 50% 50%;
	border: 1px solid transparent;

	&:hover {
		border: 1px solid transparent;
		background: url('/media/images/background-gradient.jpg') 50% 0%;
	}
`;
exports.StyledPlusOutlined = (0, styled_components_1.default)(icons_1.PlusOutlined) `
	svg {
		width: 2rem;
		height: 2rem;
	}
`;
exports.StyledPlayCircleOutlined = (0, styled_components_1.default)(icons_1.PlayCircleFilled) `
	z-index: 1;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	svg {
		${(0, styled_breakpoints_1.up)('xs')} {
			width: 4rem;
			height: 4rem;
		}
		${(0, styled_breakpoints_1.up)('sm')} {
			width: 3rem;
			height: 3rem;
		}
		${(0, styled_breakpoints_1.up)('lg')} {
			width: 4rem;
			height: 4rem;
		}
	}
`;
exports.MultipleAssetsIcon = (0, styled_components_1.default)(streamlinehq_picture_stack_svg_1.default) `
	z-index: 4;
	position: absolute;
	top: 1rem;
	right: 1rem;
	width: 1.5rem;
	height: 1.5rem;
`;
exports.GalleryCardTitle = styled_components_1.default.div `
	position: absolute;
	left: 0;
	bottom: 0;
	color: ${props => props.theme.color.white};
	font-size: 1rem;
	font-weight: bold;
	text-overflow: ellipsis;
	white-space: nowrap;
	word-break: keep-all;
	overflow: hidden;
	width: 100%;
	background-image: linear-gradient(to top, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0));
	padding: 2rem 1rem 1rem;
	transition: 0.3s;
`;
exports.GalleryCard = styled_components_1.default.div `
	position: relative;
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	transition: 0.3s ease-in-out;

	svg {
		color: ${props => props.theme.color.white};
	}

	&:hover {
		${exports.GalleryCardTitle} {
			padding-top: 4rem;
			background-image: linear-gradient(to top, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0));
		}
	}
`;
exports.DetailIcon = (0, styled_components_1.default)(icons_1.EyeOutlined) `
	width: 3rem;
	height: 3rem;
	padding: 1rem;
	border-radius: 4rem;
	background: rgb(80, 80, 80);
	color: white;
	display: flex;
	justify-content: center;
	align-items: center;
	opacity: 0;
	transition: 0.3s;
	transform: scale(0.5);
`;
exports.StyledDivOverlay = styled_components_1.default.div `
	position: absolute;
	color: ${props => props.theme.color.white};
	width: 100%;
	height: 100%;
	display: flex;
	font-size: ${props => props.theme.fontSizes.m};
	flex-direction: column;
	justify-content: center;
	align-items: center;
	cursor: pointer;
	z-index: 1;

	&:hover {
		${exports.DetailIcon} {
			opacity: 1;
			transform: scale(1);
		}
	}
`;
